import Modal from "../dialog";
import cx from "../../utils/tailwind-merge";
import "../../utils/tailwind.css";

const ConfirmationModal = (props) => {
  const { children, className, isOpen, rootClassName } = props;
  return (
    <Modal className="z-1000" isOpen={isOpen}>
      <div className={cx("min-w-[350px] text-xs flex flex-col", rootClassName)}>
        <div className={cx("confirmation-modal flex flex-col justify-between", className)}>{children}</div>
      </div>
    </Modal>
  );
};

const ConfirmationModalTitle = (props) => {
  const { children, className, ...restProps } = props;
  return (
    <div className={cx("confirmation-modal-title text-md text-base text-primary-text font-semibold font-inter", className)} {...restProps}>
      {children}
    </div>
  );
};

const ConfirmationModalTitleBody = (props) => {
  const { children, className, ...restProps } = props;
  return (
    <div className={cx("confirmation-modal-body", className)} {...restProps}>
      {children}
    </div>
  );
};

ConfirmationModal.Title = ConfirmationModalTitle;
ConfirmationModal.Body = ConfirmationModalTitleBody;

export default ConfirmationModal;
